import { Bar } from "./bar.model";
import { Profile } from "./profile.model";

export interface BarLists {
    items: BarList[]
}

export interface BarList {
    name: string;
    type: ListType;
    icon?: string;
    id?: string;
    owner?: string;
    size?: number;
    followers?: number;
    lastUpdate?: number;
    bars?: Bar[];

    //Aux
    ownerInfo?: Profile;
    lastSeen?: number;
}

export enum ListType {
    "public" = 0, "private" = 1, "shared" = 2
}

export enum Order {
    "recent", "alphabetically"
}

export const sortAlfaphetically = (lists: BarList[]) => {
    lists.sort((a, b) => {
        const nombreA = a.name.toLowerCase();
        const nombreB = b.name.toLowerCase();

        if (nombreA < nombreB) {
            return -1;
        }
        if (nombreA > nombreB) {
            return 1;
        }
        return 0;
    });
}

export const sortRecent = (lists: BarList[]) => {
    lists.sort((a, b) => {
        const lastUpdateA = a.lastUpdate!;
        const lastUpdateB = b.lastUpdate!;

        if (lastUpdateA < lastUpdateB) {
            return 1;
        }
        if (lastUpdateA > lastUpdateB) {
            return -1;
        }
        return 0;
    });
}